/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Pricing_NoteInputs */



/**
* | output |
* | --- |
* | "Estimates exclude storage costs" |
*
* @param {Usage_Pricing_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_pricing_note = /** @type {((inputs?: Usage_Pricing_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Pricing_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les estimations excluent les frais de stockage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Schätzungen schließen Lagerkosten aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le stime escludono i costi di stoccaggio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В смету не включены расходы на хранение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las estimaciones excluyen los costes de almacenamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("估算不包括仓储成本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("推定には保管費用は含まれません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमानों में भंडारण लागत शामिल नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As estimativas não incluem custos de armazenamento.")
	return /** @type {LocalizedString} */ ("Estimates exclude storage costs")
});